import { normalizeDomain } from "@productlane/lib/src/domain"

interface CompanyMatch {
	id: string
	name: string | null
	domains?: readonly string[] | null
}

export function findCompanyByDomain<T extends CompanyMatch>(
	companies: readonly T[],
	domain: string,
	excludeId?: string,
): T | undefined {
	const normalized = normalizeDomain(domain)
	if (!normalized) {
		return undefined
	}
	return companies.find(
		(company) =>
			company.id !== excludeId &&
			company.domains?.some((d) => normalizeDomain(d) === normalized),
	)
}

export function findCompanyByName<T extends CompanyMatch>(
	companies: readonly T[],
	name: string,
	excludeId?: string,
): T | undefined {
	const normalized = name.trim().toLowerCase()
	if (!normalized) {
		return undefined
	}
	return companies.find(
		(company) =>
			company.id !== excludeId &&
			company.name?.trim().toLowerCase() === normalized,
	)
}
